// Migrated from globals.scss `.comment-form-wrapper` (sole owners: the page-authored wrapper
// Box in src/pages/blog/[blogsDetails].tsx and src/pages/use-cases/[useCase].tsx). The base box
// styling and `.comment-form-heading`/`.comment-form-subheading` overrides are only ever
// rendered by the blog page (page-authored Typography siblings of <CommentForm>); the
// `.blog-comment-form .common-input-css` MUI-input tiers are only ever rendered by CommentForm
// itself, which the blog page nests inside this wrapper. On the use-cases page this wrapper
// scopes an unrelated `renderLayoutMain()` contact grid with none of those descendants, so the
// nested overrides are inert there — kept in this one shared constant anyway (same reasoning as
// blogExpertFormWrapperSx's `.form-button` tier) rather than forking a second copy. The base box
// styling (padding/background/border/shadow/margin) IS real and visible on both pages.
import {shadows, borderRadius, colors} from '@/styles/tokens';

export const commentFormWrapperSx = {
    padding: '30px 30px 40px 30px !important',
    backgroundColor: colors.text.inverse,
    border: `1px solid ${colors.neutral.borderLight}`,
    borderRadius: borderRadius.xl,
    boxShadow: shadows.lg,
    marginBottom: '30px !important',
    '& .comment-form-heading': {
        fontSize: '32px !important'
    },
    '& .comment-form-subheading': {
        fontSize: '18px !important',
        color: '#374151 !important',
        marginTop: '6px !important',
        marginBottom: '20px !important'
    },
    '& .blog-comment-form .common-input-css .MuiOutlinedInput-root:hover fieldset': {
        borderColor: 'rgba(31, 63, 122, 0.79) !important'
    },
    '& .blog-comment-form .common-input-css .MuiOutlinedInput-root.Mui-focused fieldset': {
        borderColor: 'rgba(31, 63, 122, 0.79) !important'
    },
    '& .blog-comment-form .common-input-css .MuiOutlinedInput-root.Mui-focused': {
        boxShadow: `${shadows.focusRing} !important`,
        borderRadius: borderRadius.lg
    }
} as const;
